import { useRouter } from 'next/router';

export function useIsMyGindumac() {
  const router = useRouter();
  return router.pathname == '/my' || router.pathname.includes('/my/');
}
